import appDataApi from '../../api/app-data'

const state = {
  companyData: null,
  swasCategory: null,
  callingCodes: []
}

const getters = {
  companyData: state => state.companyData,
  callingCodes: state => state.callingCodes,
  swasCategory: state => state.swasCategory
}

const mutations = {
  setCompanyData (state, data) {
    state.companyData = data
  },
  setCallingCodes (state, data) {
    state.callingCodes = data
  },
  setSwasCategory (state, data) {
    state.swasCategory = data
  }
}

const actions = {
  fetchCompanyData (context) {
    return appDataApi.findCompanies().then(response => {
      const data = response.data
      context.commit('setCompanyData', data)
      return data
    })
  },
  fetchCallingCodes (context) {
    return appDataApi.findCallingCodes().then(response => {
      const data = response.data
      context.commit('setCallingCodes', data)
      return data
    })
  },
  fetchSwasCategory (context) {
    return appDataApi.findRules().then(response => {
      const data = response.data
      context.commit('setSwasCategory', data)
      return data
    })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/app-data.js